export var DocReaderVariantType;
(function (DocReaderVariantType) {
    // MANDATORY VARIANTS
    DocReaderVariantType["NEUTRAL"] = "NEUTRAL";
    DocReaderVariantType["COLORED"] = "COLORED";
    // NON MANDATORY VARIANTS
    DocReaderVariantType["NEUTRAL_NON_MANDATORY"] = "NEUTRAL_NON_MANDATORY";
    DocReaderVariantType["COLORED_NON_MANDATORY"] = "COLORED_NON_MANDATORY";
})(DocReaderVariantType || (DocReaderVariantType = {}));
//# sourceMappingURL=docReaderVariantType.js.map